import Skill from './Skill.component';

export default Skill;
